// Recorta la región elegida en el cropper y devuelve un File JPEG.
//
// A diferencia del helper equivalente de web-nutrition (utils/helpers.js), el
// canvas se dimensiona en píxeles de la imagen original y no del recorte tal
// como se ve en pantalla. Aquel dimensiona el canvas con `cropConfig.width`,
// que son píxeles de CSS, así que el resultado sale a la resolución a la que el
// navegador estaba mostrando la foto y cambia según el tamaño de la ventana en
// que se recortó. Para la foto del establecimiento, que después se muestra en
// el dashboard y en el ticket, eso se nota.
export const getCroppedImageFile = (image, cropConfig, fileName) => {
  const scaleX = image.naturalWidth / image.width;
  const scaleY = image.naturalHeight / image.height;

  const width = Math.round(cropConfig.width * scaleX);
  const height = Math.round(cropConfig.height * scaleY);

  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;

  canvas
    .getContext('2d')
    .drawImage(
      image,
      cropConfig.x * scaleX,
      cropConfig.y * scaleY,
      width,
      height,
      0,
      0,
      width,
      height,
    );

  return new Promise((resolve, reject) => {
    canvas.toBlob(blob => {
      if (!blob) {
        reject(new Error('No se pudo recortar la imagen'));
        return;
      }
      resolve(new File([blob], fileName, { type: 'image/jpeg' }));
    }, 'image/jpeg');
  });
};
